export default "__VITE_ASSET__C2Fqb9r0__"